import styled from 'styled-components';
import theme from 'v3/theme';
import { FaWhatsapp } from 'react-icons/fa';

export const WhatsAppIcon = styled(FaWhatsapp)`
  margin-right: 5px;
  color: ${theme.colors.success};
`;
